import StoreHeader from "../../components/layout/StoreHeader";
import StoreFooter from "../../components/layout/StoreFooter";
import { useSettings } from "../../context/SettingsContext";
import { RotateCcw } from "lucide-react";

const DEFAULT_TEXT = `BCP Brisbane Car Parts aims to ensure every customer is satisfied with their purchase.

Eligibility for Refund
Refunds are available on parts returned within 30 days of purchase, provided they are in the same condition as sold and accompanied by proof of purchase. Electrical components and custom-ordered parts are non-refundable unless faulty.

How to Request a Refund
Contact us at info@brisbanecarparts.com.au or call us with your order number and reason for return. We will provide a return authorisation and instructions.

Processing Time
Refunds are processed within 5–7 business days of receiving the returned item. Refunds are issued to the original payment method.

Faulty or Incorrect Parts
If you receive a faulty or incorrect part, we will cover the return shipping cost and provide a full refund or replacement at no charge.

Warranty Claims
Parts under warranty that develop a fault will be replaced or refunded in accordance with our Warranty Policy. Please contact us with your invoice number.

Contact
info@brisbanecarparts.com.au · 1800 650 650`;

export default function RefundPolicy() {
  const { settings } = useSettings();
  const text = settings.refund_policy?.trim() || DEFAULT_TEXT;

  return (
    <div className="bg-white min-h-screen">
      <StoreHeader />
      <div className="bg-[#0b1a3b] py-14">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-[#e31e24] font-mono text-[11px] uppercase tracking-[0.3em] mb-2 flex items-center gap-2">
            <RotateCcw className="h-3.5 w-3.5" /> Customer support
          </div>
          <h1 className="font-heading text-[44px] font-black uppercase text-white leading-tight">
            Refund Policy
          </h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-12">
        <div className="prose prose-zinc max-w-none whitespace-pre-line text-[15px] leading-relaxed text-zinc-700">
          {text}
        </div>
      </div>
      <StoreFooter />
    </div>
  );
}
